import { render } from "./ClientReportesVentas.vue?vue&type=template&id=616fceff&scoped=true"
import script from "./ClientReportesVentas.vue?vue&type=script&lang=js"
export * from "./ClientReportesVentas.vue?vue&type=script&lang=js"

import "./ClientReportesVentas.vue?vue&type=style&index=0&id=616fceff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616fceff"]])

export default __exports__